var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"burger-btn",class:{ open: _vm.value },on:{"click":function($event){return _vm.$emit('input', !_vm.value)}}},[_c('div',{staticClass:"burger-btn__line"}),_vm._v(" "),_c('div',{staticClass:"burger-btn__line"}),_vm._v(" "),_c('div',{staticClass:"burger-btn__line"})])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/templates/components/ui-components/burger-btn/index.vue?vue&type=template&id=7b534f7f&
// module id = 1354
// module chunks = 0